import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { LimiteDeError } from "./components/limite-de-error";
import { SessionProvider } from "./lib/auth";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("No se encontro el contenedor #root");

createRoot(container).render(
  /*
   * La sesion va arriba del router para que sea una sola en toda la pagina.
   * No cuesta nada en las pantallas publicas: recien pregunta por ella la
   * primera pantalla que la necesita (`lib/auth.tsx`).
   */
  <StrictMode>
    <BrowserRouter>
      <LimiteDeError>
        <SessionProvider>
          <App />
        </SessionProvider>
      </LimiteDeError>
    </BrowserRouter>
  </StrictMode>,
);
